export const cartKeys = {
  all: ["cart"] as const,
  detail: () => [...cartKeys.all, "detail"] as const,
  count: () => [...cartKeys.all, "count"] as const,
};
